import {
  checkingUnnalocatedPos,
  getSavedUnnalocatedPos,
  saveUnnalocatedPos,
} from "@utils/saveUnnalocatedMinersPosotions";
import {
  ActionAddUnallocatedMiner,
  ActionBaseUnallocatedMiners,
  ActionRemoveUnallocatedMiner,
  ActionReorderItems,
  ActionSetMinerColor,
  ActionSetUnallocatedMiners,
  ActionTypesUnallocatedMiners,
  IUnrackItem,
} from "./actionTypes";

// const MOCK: IRackItem[] = [
//   {
//     id: "dsdfgsdfg2",
//     miner_name: "001C001-Ae43",
//     user_color: `#D8A${Math.floor(Math.random() * 100)}`,
//     status: MinerStatuses.LOW,
//     rejected: 200,
//     accepted: 430,
//   },
//   {
//     id: "dsdf234dfg2",
//     miner_name: "001C001-Ae44",
//     user_color: `#D8A${Math.floor(Math.random() * 100)}`,
//     status: MinerStatuses.LOW,
//     rejected: 200,
//     accepted: 430,
//   },
//   {
//     id: "ds234g345fg2",
//     miner_name: "001C001-Ae45",
//     user_color: `#D8A${Math.floor(Math.random() * 100)}`,
//     status: MinerStatuses.LOW,
//     rejected: 200,
//     accepted: 430,
//   },
// ];

 // В TS у user_id тип string, в реальности number. Зачем тогда мы используем TS?
const equalUserID = (item: IUnrackItem, user_id: string) => `${item.user_id}` === user_id;

interface IState {
  valid: boolean;
  unallocatedMiners: IUnrackItem[];
}

const initialState: IState = {
  valid: true,
  unallocatedMiners: [],
};

const reducer = (
  state = initialState,
  action: ActionBaseUnallocatedMiners
): IState => {
  switch (action.type) {
    case ActionTypesUnallocatedMiners.SET_MINERS:
      if (!getSavedUnnalocatedPos()) {
        return {
          ...state,
          valid: true,
          unallocatedMiners: saveUnnalocatedPos(
            (action as ActionSetUnallocatedMiners).payload
          ),
        };
      }
      return {
        ...state,
        unallocatedMiners: checkingUnnalocatedPos(
          (action as ActionSetUnallocatedMiners).payload
        ),
        valid: true,
      };
    case ActionTypesUnallocatedMiners.REMOVE_MINER:
      const id = (action as ActionRemoveUnallocatedMiner).payload;
      const filtered = state.unallocatedMiners.filter((m) => m.id !== id);
      return {
        ...state,
        unallocatedMiners: filtered,
      };
    case ActionTypesUnallocatedMiners.ADD_MINER:
      return {
        ...state,
        unallocatedMiners: saveUnnalocatedPos([
          (action as ActionAddUnallocatedMiner).payload,
          ...state.unallocatedMiners,
        ]),
      };
    case ActionTypesUnallocatedMiners.UNRACKS_INVALIDATE:
      return { ...state, valid: false };
    case ActionTypesUnallocatedMiners.REORDER_ITEMS:
      const reorderPl = (action as ActionReorderItems).payload;

      const overIndex = state.unallocatedMiners.findIndex(
        (un) => un.id === reorderPl.placedId
      );
      const draggedIndex = state.unallocatedMiners.findIndex(
        (un) => un.id === reorderPl.draggedId
      );
      if (overIndex === -1 || draggedIndex === -1) return state;

      const filteredItems = state.unallocatedMiners.filter(
        (m) => m.id !== reorderPl.draggedId
      );
      const neirElem = filteredItems[overIndex];

      const a = [
        ...filteredItems.slice(0, overIndex),
        state.unallocatedMiners[draggedIndex],
        neirElem,
        ...filteredItems.slice(overIndex + 1),
      ];
      console.log(a);

      return {
        ...state,
        unallocatedMiners: saveUnnalocatedPos(a),
      };
    case ActionTypesUnallocatedMiners.SET_MINER_COLOR: {
      const act = action as ActionSetMinerColor;
      return {
        ...state,
        unallocatedMiners: state.unallocatedMiners.map(
          miner => equalUserID(miner, act.payload.user_id) ? {...miner, user_color: act.payload.color} : miner),
      };
    }
    default:
      return {
        ...state,
      };
  }
};

export default reducer;
